<div class="betslip-over-ask-pending-content">
    <div class="betslip-over-ask-pending-content-header">
        <span class="betslip-over-ask-pending-content-title">{{ messages.reviewTitle }}</span>
        <p class="betslip-over-ask-pending-content-info-text">{{ messages.reviewInformation }}</p>
        <ms-timer-progress-bar
            [shouldShowInformation]="true"
            [informationText]="messages.progressBarInfoText"
            [step]="progressBarStep"
            [totalDuration]="overAskTimeout"
            [shouldShowPercentage]="shouldShowPercentage"
            [loop]="false"
            [pauseProgressBar]="pauseProgressBar"
            (progress)="onProgress($event)"></ms-timer-progress-bar>
    </div>
    <bs-digital-over-ask-pick-list
        class="betslip-over-ask-pick-list-component"
        [props]="pickListProps"
        [overAskFlowState]="overAskFlowState"
        [oddsDisplayFormat]="oddsDisplayFormat">
    </bs-digital-over-ask-pick-list>
</div>
<div class="betslip-over-ask-pending-footer">
    <button ds-button kind="secondary" variant="outline" size="large" (click)="cancelOverAsk()">
        {{ messages.cancelButtonTitle }}
    </button>
</div>
